import { ParamsSearch } from './../models/paramsSearch';
import { UserService } from './user.service';
import { Router } from '@angular/router';



import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Injectable()
export class RutasService{

  rutas: Ruta [] = [];
   params = {
    origenProvincia:  '',
    origenLocalidad:    '',
    destinoProvincia:  '',
    destinoLocalidad:  '',
    tienesCoche: '',
    sinCoche: '',
    destinoCentro: '',
    mostrarRutaConParada: '',
    finDeSemana: 'no',


  };

  constructor(

    private httpClient: HttpClient,
    private userService: UserService,
    private router: Router){



  }
  clearSearch() {
    this.params.origenProvincia = '';
    this.params.origenLocalidad = '';
    this.params.destinoProvincia = '';
    this.params.destinoLocalidad = '';
    this.params.destinoCentro = '';
    this.params.tienesCoche = '';
    this.params.sinCoche = '';
    this.params.mostrarRutaConParada = '';
    this.params.finDeSemana = 'no';

  }
  getParams(origenProvincia, origenLocalidad, destinoProvincia, destinoLocalidad, tienesCoche, sinCoche, aceptaParadas, destinoCentro, finDeSemana){

    this.params.origenProvincia = origenProvincia;
    this.params.origenLocalidad = origenLocalidad;
    this.params.destinoProvincia = destinoProvincia;
    this.params.destinoLocalidad = destinoLocalidad;
    this.params.tienesCoche = tienesCoche;
    this.params.sinCoche = sinCoche;
    this.params.mostrarRutaConParada = aceptaParadas;
    this.params.destinoCentro = destinoCentro;
    this.params.finDeSemana = finDeSemana;




    return;

  }
  agregarRuta(valoresRuta: any) {

    const params = JSON.stringify(valoresRuta);
    //const paramsOk = params.replace(/['”]+/g, '');
    // const paramsOk = params.replace(/"/g, "'");

    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/guardar';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(url, params, { headers: headers });


  }

  getRutas(){

    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/getRutas';
    return this.httpClient.get(url);

  }


  getMisRutas(user: string ){

    const params = JSON.stringify(user);
    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/getMisRutas/' + user ;
    return this.httpClient.get(url);

  }

  getRutasFiltradas(data){

// console.log(data)
    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/getRutasFiltradas/';

  //console.log(url)

    return this.httpClient.post(url, data);


  }
//   getRutasFiltradas(origenLocalidad: string, destinoLocalidad: string, tienesCoche: string, sinCoche: string, aceptaParadas: string,finDeSemana: string,  destinoCentro?: string){


//     const url = 'https://docentesenruta.eu-4.evennode.com/rutas/getRutasFiltradas/' + origenLocalidad + '/'  + destinoLocalidad + '/' + tienesCoche + '/' + sinCoche + '/' + aceptaParadas + '/' + finDeSemana + '/' + destinoCentro ;

// console.log(url)

//     return this.httpClient.get(url);

//   }

  getRutaOk(id: string){

    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/' + id ;
    return this.httpClient.get(url);

  }


  // tslint:disable-next-line:typedef
   getRuta(idx: string){
      return this.rutas[idx];
   }


 getParada(parada: string){

  return parada;

 }


 editarRuta(ruta: any, tipo?, creador?, user?){

  const params = ruta;
  const url = 'https://docentesenruta.eu-4.evennode.com/rutas/' + ruta._id + '/' + tipo + '/' + creador + '/' + user;
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  return this.httpClient.put(url, params, { headers: headers });

  }


 eliminarRuta(ruta: any){

  const params = ruta;
  const url = 'https://docentesenruta.eu-4.evennode.com/rutas/delete/' + ruta._id ;
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  return this.httpClient.delete(url, params);

  }

  updateMails(email1, email2) {

    //const params = user;
    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/updateMail/' + email1 + '/' + email2;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.put(url, { headers: headers });
}
  updateMailsUsuarios(email1, email2) {

    //const params = user;
    const url = 'https://docentesenruta.eu-4.evennode.com/rutas/updateMailUsuarios/' + email1 + '/' + email2;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.put(url, { headers: headers });
}
updateMailsParadaSoli(email1, email2) {

  //const params = user;
  const url = 'https://docentesenruta.eu-4.evennode.com/rutas/updateMailParadaSoli/' + email1 + '/' + email2;
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  return this.httpClient.put(url, { headers: headers });
}

}

export interface Ruta{
  origen: string;
  destinoLocalidad: string;
  destinoCentro: string;
  paradas: any;
  plazas: number;
  creador: string;
  paradasSolicitadas: [];
  cerrada: boolean;
  fechaInicio;
  fechaFin;
  finDeSemana;



}
